module.exports = {
      id: "no-image-usage",
      viewBox: "0 0 254 195",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#no-image",
      toString: function () {
        return this.url;
      }
    }